import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class SelectSpecialtyService {
  dataSourceTable = new BehaviorSubject<any>([]);

  constructor() {}
}
